import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import CustomDatePicker from "../../general/CustomDatePicker";
import CustomInput from "../../general/CustomInput";

const ActivationForm = ({
  isEditing,
  form,
  errors,
  submitting,
  minSelectableDate,
  onChange,
  onDateChange,
  onSubmit,
  onCancel,
  itemNumber,
  totalItems,
  productName,
}) => {
  const showBadge = totalItems > 1;

  return (
  <form className="activation-page__form" onSubmit={onSubmit}>
    <div className="activation-page__form-header">
      {showBadge && (
        <span className="activation-page__item-badge">
          eSIM {itemNumber} of {totalItems}
        </span>
      )}
      <h1 className="activation-page__title">
        {isEditing ? "Update Your Details" : "Enter Phone Details"}
      </h1>
      {productName && (
        <p className="activation-page__product-name">{productName}</p>
      )}
      <p className="activation-page__subtitle">
        {isEditing
          ? "Enter your corrected IMEI, EID, and activation date below."
          : "These details are required to activate your eSIM. Activation will occur automatically on the selected date."}
      </p>
    </div>

    <div className="activation-page__form-body">
      {isEditing && (
        <div className="activation-page__warning">
          <FiAlertTriangle className="activation-page__warning-icon" />
          Your details have already been submitted. Any changes will be
          reviewed by our team before being applied.
        </div>
      )}

      <div className="activation-page__field">
        <CustomInput
          name="imei"
          value={form.imei}
          onChange={onChange}
          floatingLabel="IMEI (15-digit identifier)"
        />
        {errors.imei && (
          <span className="activation-page__error">{errors.imei}</span>
        )}
      </div>

      <div className="activation-page__field">
        <CustomInput
          name="eid"
          value={form.eid}
          onChange={onChange}
          floatingLabel="EID (32-digit identifier)"
        />
        {errors.eid && (
          <span className="activation-page__error">{errors.eid}</span>
        )}
      </div>

      <div className="activation-page__field">
        <CustomDatePicker
          selectedDate={form.activationDate}
          handleDateChange={onDateChange}
          floatingLabel="Activation Date"
          minDate={minSelectableDate}
        />
        {errors.activationDate && (
          <span className="activation-page__error">{errors.activationDate}</span>
        )}
      </div>

      <div className="activation-page__form-actions">
        <button
          className="activation-page__submit"
          type="submit"
          disabled={submitting}
        >
          {submitting
            ? "Submitting…"
            : isEditing
              ? "Update Details"
              : "Submit Details"}
        </button>

        {isEditing && (
          <button
            type="button"
            className="activation-page__cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  </form>
  );
};

export default ActivationForm;
